import React from "react";
import BMICalculator from "./components/BMICalculator";

function App() {
  return <BMICalculator />;
}

export default App;
